import { Entity } from "../../common/entity";
import { DocumentationPageApproval, DocumentationPageSnapshot, ElementGroupSnapshot, } from "../../dsm";
import { DocumentationPageV2 } from "../../dsm/elements/documentation-page-v2";
import { ElementGroup } from "../../dsm/elements/group";
import { z } from "zod";
//
// Room
//
export const DesignSystemVersionRoom = Entity.extend({
    designSystemVersionId: z.string(),
    liveblocksId: z.string(),
});
//
// Room state
//
export const DesignSystemVersionRoomInternalSettings = z.object({
    routingVersion: z.string(),
    isDraftFeatureAdopted: z.boolean(),
    isApprovalFeatureEnabled: z.boolean(),
    approvalRequiredForPublishing: z.boolean(),
});
export const DesignSystemVersionRoomInitialState = z.object({
    pages: z.array(DocumentationPageV2),
    groups: z.array(ElementGroup),
    pageSnapshots: z.array(DocumentationPageSnapshot),
    groupSnapshots: z.array(ElementGroupSnapshot),
    pageApprovals: z.array(DocumentationPageApproval),
    internalSettings: DesignSystemVersionRoomInternalSettings,
    pageHashes: z.record(z.string()).optional(),
    storageVersion: z.literal(1).or(z.literal(2)),
});
export const DesignSystemVersionRoomUpdate = z.object({
    pages: z.array(DocumentationPageV2),
    groups: z.array(ElementGroup),
    pageIdsToDelete: z.array(z.string()),
    groupIdsToDelete: z.array(z.string()),
    pageSnapshots: z.array(DocumentationPageSnapshot),
    groupSnapshots: z.array(ElementGroupSnapshot),
    pageSnapshotIdsToDelete: z.array(z.string()),
    groupSnapshotIdsToDelete: z.array(z.string()),
    pageHashesToUpdate: z.record(z.string(), z.string()),
    pageApprovals: z.array(DocumentationPageApproval),
    pageApprovalIdsToDelete: z.array(z.string()),
    executedTransactionIds: z.array(z.string()),
});
